export default __webpack_public_path__ + "static/media/card-3.b0472f0f.png";